export const AskGraveMoveType: { [key: number]: string } = {
  1: "개장",
  2: "이장",
};

export const faqType: { [key: number]: string } = {
  1: "추모공원 검색",
  2: "이장/개장",
  3: "묘 조성",
  4: "벌초",
  5: "상조",
  6: "상속상담",
  7: "생전/유품정리",
  8: "기타",
};

export const CooperateType: { [key: number]: string } = {
  1: "추모시설",
  2: "파트너",
};

export const BlogCategory: { [key: number]: string } = {
  1: "조상님복덕방 소식",
  2: "장례 문화",
  3: "추모 예절",
  4: "기타",
};
